import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import top_students_icon from "../../../assets/Group633.svg";
import star_top_icon from "../../../assets/star_top_icon.svg";
import LoadingSpinner from "../../../components/LoadingSpinner";
import { USER_TYPE } from "../../../constants/common";
import schoolServices from "../../../services/schoolServices";
import { getLanguage } from "../../../utils/getLanguage";
import { useNavigateWithLang } from "../../../utils/navigation";

const TeacherTopTenStudents = () => {
  const { t } = useTranslation();
  const lang = getLanguage();
  const isRtl = lang === "ar";

  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(true);

  const getTopTenStudents = async () => {
    try {
      const response = await schoolServices.getSchoolTopTenStudents();
      setStudents(response);
    } catch (error) {
      console.error("Failed to fetch top ten students:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getTopTenStudents();
  }, []);

  return (
    <div>
      <h1 className="mb-6 flex items-center text-xl font-semibold text-blue-500 lg:text-4xl xl:text-3xl">
        <span className="flex items-center gap-4">
          <img src={top_students_icon} alt="star" className="h-10 w-10 lg:h-12 lg:w-12" />
          <span className="text-2xl lg:text-3xl">
            {t("stars_of")} {new Date().getFullYear()}
          </span>
        </span>
      </h1>

      {loading ? (
        <div className="text-center text-lg">
          <LoadingSpinner />
        </div>
      ) : students?.length === 0 ? (
        <div className="text-center text-lg text-gray-500">{t("no_data_available")}</div>
      ) : (
        students?.map((student, index) => (
          <div
            key={student.student_id}
            className="relative mb-3 grid grid-cols-[50px_1fr_1fr_1fr_1fr] items-center gap-4 rounded-lg bg-blue-500 p-4 text-white shadow-md"
          >
            <div className="text-4xl font-semibold text-orange-500">{index + 1}</div>

            <div>
              <div className="text-base font-light">{t("student")}</div>
              <div className="text-xl font-semibold">{student.student_name}</div>
            </div>

            <div>
              <div className="text-base font-light">{t("teacher")}</div>
              <div className="text-xl font-semibold">{student.teacher_name}</div>
            </div>

            <div>
              <div className="text-base font-light">{t("classroom")}</div>
              <div className="text-xl font-semibold">{student.classroom_name}</div>
            </div>

            <div className="text-end">
              <div className="text-base font-light">{t("points")}</div>
              <div className="text-xl font-semibold">{student.total_points}</div>
            </div>

            <img
              className={`absolute ${isRtl ? "left-[-25px]" : "right-[-25px]"} top-[-20px] h-14 w-14 lg:top-[-25px]`}
              src={star_top_icon}
              alt="star"
            />
          </div>
        ))
      )}
    </div>
  );
};

export default TeacherTopTenStudents;
